import apiClient from '../../services/api';

export type CarbonPathway = 'restoration_agroforestry' | 'irrigated_rice';

export interface CarbonAreaAccounting {
  gross_ha: number | null;
  enrolled_ha: number | null;
  excluded_ha: number | null;
  suitable_ha: number | null;
  methodology_eligible_ha: number | null;
  implemented_ha: number | null;
  monitored_ha: number | null;
  unit: string;
  status: 'unknown' | string;
}

export interface CarbonProjectRecord {
  id: string;
  title: string;
  pathway: CarbonPathway;
  pathway_label: string;
  location: string | null;
  objectives: string | null;
  development_status: string;
  my_role: string;
  area: CarbonAreaAccounting;
  created_at: string | null;
  updated_at: string | null;
}

export interface CarbonProjectDraft {
  title: string;
  pathway: CarbonPathway;
  location?: string;
  objectives?: string;
}

export async function listCarbonProjects(): Promise<CarbonProjectRecord[]> {
  const { data } = await apiClient.get<{ projects: CarbonProjectRecord[] }>('/carbon-projects');
  return data.projects ?? [];
}

export async function createCarbonProject(draft: CarbonProjectDraft): Promise<CarbonProjectRecord> {
  const { data } = await apiClient.post<CarbonProjectRecord>('/carbon-projects', draft);
  return data;
}

export function apiErrorMessage(error: unknown, fallback: string): string {
  const detail = (error as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0] as { msg?: string };
    if (first?.msg) return first.msg;
  }
  return fallback;
}
